
<script>

	export default{
		props:[],
		data(){

			return {
				datePickerConfig:{
					'format':'DD/MM/YYYY',
					'showClose': true
				},
				status: "ABERTO",
				fromDate: "",
				toDate: "",
				produtos: []

			}
		},
		methods:{
			initDates: function(){

				let m = moment();

				m.set({hour:0,minute:0,second:0,millisecond:0});

				this.toDate = moment();
				this.toDate.set({hour:0,minute:0,second:0,millisecond:0});

				this.fromDate = m;
				this.fromDate.subtract(1,'month');

			},
			loadProdutos: function(){

				$(".loading").show();
				var vm = this;
				let data = {
					from: moment(this.fromDate,"D/MM/YYYY").format("Y-M-DD"),
					to: moment(this.toDate,"D/MM/YYYY").format("Y-M-DD"),	
					status:this.status
				};
				axios.get('/distribuidor/ranking/produtos/list',{
					params: data
				}).then(function(response){

					vm.produtos = response.data;
					$(".loading").hide();
				}).catch(function(error){
					console.log(error);
					alert("Erro ao carregar Produtos");
					$(".loading").hide();
				});
			},
			changeData: function() {
				this.loadProdutos();
			}
		},
		computed:{
			orderedProdutos: function () {
    return _.orderBy(this.produtos, 'valor','desc');
  }
		},
		created: function(){
			this.initDates();
		},
		mounted: function(){
			this.loadProdutos();
		}
	}

</script>

<template>

	<div class="col-md-12">
		<div class="row">
			<div class="col-md-4">
					<label for="" class="text-primary label-status">Status</label>
					<select name="" id="" class="form-control " v-model="status"  @change="changeData">
						<option value="">TODOS</option>
						<option value="ABERTO">Abertos</option>
						<!--<option value="INICIADO">Iniciados</option> -->
						<option value="ENVIADO">Enviado</option>
						<option value="DELETADO">Deletados</option>

					</select>
			</div>

			<div class="col-md-4">
				<div class="form-group">
					<label for="">De</label>

					<date-picker  v-model="fromDate" @dp-change="changeData" :config="datePickerConfig"></date-picker>
				</div>
			</div>

			<div class="col-md-4">
				<div class="form-group">
					<label for="">Até</label>
					<date-picker  v-model="toDate" @dp-change="changeData" :config="datePickerConfig"></date-picker>

				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12 printer">

				<table class="table table-bordered table-striped">
					<thead>
					<tr>
						<th class="text-center">Código</th>
						<th class="text-center">Produto</th>
						<th class="text-center">Quantidade</th>
						<th class="text-center">Valor</th>
					</tr>
					</thead>
					<tbody>
					<tr class="text-center" v-for="produto in orderedProdutos">
						<td>{{produto.codigo}}</td>
						<td>{{produto.produto}}</td>
						<td>{{produto.quantidade}}</td>
						<td>R$ {{produto.valor.toFixed(2).replace(".",",")}}</td>
					</tr>
					</tbody>
				</table>

			</div>

		</div>

	</div>

</template>

<style scoped="">

	@media only print{

	.filter,.breadcrumb,.navbar{
		display: none;
	}
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor_ranking/Produtos.vue